import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import { useSettings } from "../../core/contexts/SettingsProvider";
import SearchIcon from "@mui/icons-material/Search";
import { useStyles } from "./styles/toolbar";
import { InputBase } from "@mui/material";
import { ChangeEventHandler } from "react";

type AdminToolbarProps = {
  children?: React.ReactNode;
  title?: string;
  search?: boolean;
  searchOnChange?: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  placeholderSearch?: string;
};

const AdminToolbar = ({
  children,
  title,
  search,
  searchOnChange,
  placeholderSearch,
}: AdminToolbarProps) => {
  const { toggleDrawer } = useSettings();
  const classes = useStyles();

  return (
    <Toolbar sx={{ px: { xs: 3, sm: 6 } }}>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={toggleDrawer}
        sx={{
          display: { lg: "none" },
          marginRight: 2,
        }}
      >
        <MenuIcon />
      </IconButton>
      <Typography variant="h2" component="h1" sx={{ flexGrow: 1 }}>
        {title}
      </Typography>
      {placeholderSearch !== undefined ? (
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            className={classes.inputBase}
            onChange={searchOnChange}
            placeholder={placeholderSearch}
            inputProps={{ "aria-label": "search" }}
          />
        </div>
      ) : undefined}
      {children}
    </Toolbar>
  );
};

export default AdminToolbar;
